module.exports = __webpack_public_path__ + "img/logoNew.18b82359.png";